module.exports = __webpack_public_path__ + "img/ico_home_tab_press@3x.91a0249c.png";